import scrumBoardActions from './actions'
import mediaAction from '../qbmedia/actions'
import objectAction from '../object/actions'
const initialState = {
    boards: [],
    columns: {
        column1: {
            id: 'column1',
            board_id: 'board-1',
            task_orders: [],
            title: 'Một số thông tin',
            editing: false,
        },
        column2: {
            id: 'column2',
            board_id: 'board-2',
            task_orders: [],
            title: 'Báo cáo hiện có',
            editing: false,
        },
        column3: {
            id: 'column3',
            board_id: 'board-1',
            task_orders: [],
            title: 'Báo cáo đã xem',
            editing: false,
        },
        column4: {
            id: 'column4',
            board_id: 'board-1',
            task_orders: [],
            title: 'Báo cáo cần làm lại',
            editing: false,
        },
        column5: {
            id: 'column5',
            board_id: 'board-1',
            task_orders: [],
            title: 'Báo cáo được chấp nhận',
            editing: false,
        },
    },
    tasks: [],
    searchText: '',
    labels: {},
    listUpdateHashTag: [],
    VisibleModalMedia: false,
    VisibleModalObject: false,
    VisibleModalEvent: false,
    ListCurrentMedia: [],
    ListAddMedia: [],
    ListCurrentObject: [],
    ListAddObject: [],
    ListCurrentEvent: [],
    ListCommentReport: [],
    ListUserComment: [],
    totalComment: [],
    currentBoard: {},
    pageIndex: 1,
    totalSize: 0,
    listActivityTask: [],
    lastIdTask: 1,
    haveMoreData: true,
    listRanking: [],
    visibleModalCreateTask: false,
    currentListUserData: [],
    listHashTagAll: [],
    listUserSearchByText: [],
    isloadingSearch: false,
    currentUserPickUp: [],
    lstCurrentUser: [],
}

export default function scrumBoardReducer(state = initialState, action) {
    switch (action.type) {
        case scrumBoardActions.UPDATE_CURRENT_USER_PICK_UP:
            return {
                ...state,
                currentUserPickUp: action.payload.data
            }
        case scrumBoardActions.GET_LIST_CURRENT_USER_DONE:
            return {
                ...state,
                lstCurrentUser: action.payload.data
            }
        case scrumBoardActions.UPDATE_CURRENT_USER_PICKUP:
            return {
                ...state,
                currentUserPickUp: action.payload.data.length === 0 ? [] : state.currentUserPickUp.concat(action.payload.data) 
            }
        case scrumBoardActions.SEARCH_USER_BY_TEXT:
            return {
                ...state,
                isloadingSearch: true
            }
        case scrumBoardActions.SEARCH_USER_BY_TEXT_DONE:
            return {
                ...state,
                listUserSearchByText: action.payload.data,
                isloadingSearch: false
            }
        case scrumBoardActions.VISIBLE_MODAL_EVENT:
            return {
                ...state,
                VisibleModalEvent: action.payload.visible,
            }
        case scrumBoardActions.GET_LIST_HASH_TAG_ALL_DONE:
            return {
                ...state,
                listHashTagAll: action.payload.data,
            }
        case scrumBoardActions.UPDATE_LIST_CURRENT_USER_OF_TASK:
            return {
                ...state,
                currentListUserData: action.payload.data,
            }
        case scrumBoardActions.VISIBLE_MODAL_CREATE_TASK:
            return {
                ...state,
                visibleModalCreateTask: action.payload.visible,
            }
        case scrumBoardActions.GET_LIST_RANKING_IN_TASK_DONE:
            return {
                ...state,
                listRanking: action.payload.data,
            }
        case scrumBoardActions.RESET_LAST_ID_ACTIVITY_TASK:
            return {
                ...state,
                lastIdTask: 1,
                listActivityTask: [],
            }
        case scrumBoardActions.GET_ACTIVITY_TASK_DONE:
            console.log('more data', action.payload.data)
            if (action.payload.data.length === 0) {
                return {
                    ...state,
                    haveMoreData: false,
                }
            }
            return {
                ...state,
                haveMoreData: action.payload.data.length < 10 ? false : true,
                lastIdTask: state.lastIdTask + 1,
                listActivityTask: state.listActivityTask.concat(
                    action.payload.data
                ),
            }
        case scrumBoardActions.UPDATE_TOTAL_PAGE:
            return {
                ...state,
                totalSize: action.payload.data,
            }
        case scrumBoardActions.UPDATE_PAGE_INDEX_BOARD:
            return {
                ...state,
                pageIndex: action.payload.index,
            }
        case scrumBoardActions.GET_DETAIL_TASK_BY_ID_DONE:
            return {
                ...state,
                currentBoard: action.payload.data,
            }
        case scrumBoardActions.UPDATE_LIST_USER_COMMENT:
            return {
                ...state,
                ListUserComment: action.payload.data,
            }
        case scrumBoardActions.GET_LIST_COMMENT_DONE:
            return {
                ...state,
                ListCommentReport: action.payload.data,
                totalComment: state.totalComment.concat({
                    rid: action.payload.rid,
                    total: action.payload.total,
                }),
            }
        case scrumBoardActions.UPDATE_LIST_CURRENT_EVENT:
            return {
                ...state,
                ListCurrentEvent: action.payload.data,
            }
        case scrumBoardActions.GET_LIST_CURRENT_EVENT_DONE:
            return {
                ...state,
                ListCurrentEvent: action.payload.data,
            }
        case objectAction.type.GET_LIST_OBJECT_QUERY_BY_ID_DONE:
            return {
                ...state,
                ListCurrentObject: action.payload.data,
                ListAddObject: action.payload.data,
            }
        case scrumBoardActions.APPLY_TO_CURRENT_OBJECT:
            return {
                ...state,
                ListCurrentObject: action.data,
            }
        case scrumBoardActions.UPDATE_LIST_OBJECT:
            if (action.payload.ispush === true) {
                return {
                    ...state,
                    ListAddObject: state.ListAddObject.concat(
                        action.payload.data
                    ),
                }
            } else {
                let arr = state.ListAddObject
                for (let i = 0; i < arr.length; i++) {
                    if (
                        action.payload.data.object_id ===
                        state.ListAddObject[i].object_id
                    ) {
                        arr.splice(i, 1)
                    }
                }
                return {
                    ...state,
                    ListAddObject: arr,
                }
            }
        case scrumBoardActions.VISIBLE_MODAL_OBJECT:
            return {
                ...state,
                VisibleModalObject: action.payload.visible,
            }
        case scrumBoardActions.MOVE_CARD_REPORT:
            const { fromColumn, toColumn, report_id } = action.payload
            const column = state.columns
            console.log('data column move', action.payload)
            if (column[fromColumn]) {
                column[fromColumn].task_orders.splice(
                    action.payload.fromIndex,
                    1
                )
                column[toColumn].task_orders.splice(
                    action.payload.toIndex,
                    0,
                    report_id
                )
            }

            return {
                ...state,
                columns: column,
            }
        case scrumBoardActions.APPLY_TO_MEDIA:
            return {
                ...state,
                ListCurrentMedia: action.data,
            }
        case mediaAction.type.GET_LIST_MEDIA_QUERY_BY_ID_DONE:
            return {
                ...state,
                ListCurrentMedia: action.payload.data,
                ListAddMedia: action.payload.data,
            }

        case scrumBoardActions.DELETE_LIST_MEDIA:
            return {
                ...state,
                ListAddMedia: [],
            }
        case scrumBoardActions.UPDATE_LIST_MEDIA:
            if (action.payload.ispush === true) {
                return {
                    ...state,
                    ListAddMedia: state.ListAddMedia.concat(
                        action.payload.data
                    ),
                }
            } else {
                let arr = state.ListAddMedia
                for (let i = 0; i < arr.length; i++) {
                    if (action.payload.data.id === state.ListAddMedia[i].id) {
                        arr.splice(i, 1)
                    }
                }
                return {
                    ...state,
                    ListAddMedia: arr,
                }
            }

        case scrumBoardActions.VISIBLE_MODAL_MEDIA:
            return {
                ...state,
                VisibleModalMedia: action.payload.visible,
            }
        case scrumBoardActions.DELETE_LIST_TAG_UPDATE:
            return {
                ...state,
                listUpdateHashTag: [],
            }
        case scrumBoardActions.UPDATE_LIST_HASH_TAG:
            return {
                ...state,
                listUpdateHashTag: state.listUpdateHashTag.concat(
                    action.payload.data
                ),
            }
        case scrumBoardActions.SET_BOARDS_DATA:
            console.log('action payload ', action.payload)
            return { ...state, ...action.payload }

        case scrumBoardActions.SET_CURRENT_BOARD_DATA:
            return { ...state, ...action.payload }

        case scrumBoardActions.CREATE_OR_UPDATE_TASK:
            return {
                ...state,
                tasks: action.payload.tasks,
                columns: action.payload.columns,
            }

        case scrumBoardActions.EDIT_TASK:
            return {
                ...state,
                tasks: {
                    ...state.tasks,
                    [action.payload.id]: {
                        ...action.payload,
                        editing: true,
                    },
                },
            }

        case scrumBoardActions.CANCEL_EDIT_TASK:
            return {
                ...state,
                tasks: {
                    ...state.tasks,
                    [action.payload.id]: {
                        ...action.payload,
                        editing: false,
                    },
                },
            }

        case scrumBoardActions.SET_SEARCH_TEXT:
            return {
                ...state,
                searchText: action.payload,
            }

        case scrumBoardActions.SET_MOVED_TASK:
            return {
                ...state,
                columns: action.payload.columns,
                tasks: action.payload.tasks,
            }

        case scrumBoardActions.RESET_TASK: {
            return {
                ...state,
                task: initialState.task,
            }
        }

        /// COLUMNS
        case scrumBoardActions.CREATE_OR_UPDATE_COLUMN:
            return {
                ...state,
                columns: action.payload.columns,
                boards: action.payload.boards,
            }
        case scrumBoardActions.EDIT_COLUMN:
            return {
                ...state,
                columns: {
                    ...state.columns,
                    [action.payload.id]: {
                        ...action.payload,
                        editing: true,
                    },
                },
            }

        case scrumBoardActions.CANCEL_EDIT_COLUMN:
            return {
                ...state,
                columns: {
                    ...state.columns,
                    [action.payload.id]: {
                        ...action.payload,
                        editing: false,
                    },
                },
            }
        case scrumBoardActions.DELETE_COLUMN:
            return {
                ...state,
                columns: action.payload.columns,
                boards: action.payload.boards,
            }

        case scrumBoardActions.SET_MOVED_COLUMN:
            return {
                ...state,
                boards: action.payload,
            }

        case scrumBoardActions.CREATE_OR_UPDATE_BOARD:
            return {
                ...state,
                boards: action.payload,
            }
        case scrumBoardActions.EDIT_BOARD:
            return {
                ...state,
                boards: {
                    ...state.boards,
                    [action.payload.id]: {
                        ...action.payload,
                        editing: true,
                    },
                },
            }
        case scrumBoardActions.DELETE_BOARD:
            return {
                ...state,
                boards: action.payload,
            }

        case scrumBoardActions.CREATE_OR_UPDATE_LABEL:
            return {
                ...state,
                labels: {
                    ...state.labels,
                    [action.payload.id]: action.payload,
                },
            }
        case scrumBoardActions.EDIT_LABEL:
            return {
                ...state,
                labels: {
                    ...state.labels,
                    [action.payload.id]: {
                        ...action.payload,
                        editing: true,
                    },
                },
            }
        case scrumBoardActions.DELETE_LABEL:
            const LABELS = {
                ...state.labels,
            }
            delete LABELS[action.payload]
            return {
                ...state,
                labels: LABELS,
            }
        default:
            return state
    }
}
